import { useEffect, useState, useRef } from "react";
import { Row, Col, Card, ProgressBar } from "react-bootstrap";
import GraficoClientesTop20 from "../components/GraficoClientesTop20";
import GraficoVentasMensuales from "../components/GraficoVentasMensuales";
import GraficoRecurrenciaClientes from "../components/GraficoRecurrenciaClientes";
import API from "../api";

const Clientes = () => {
  const [datos, setDatos] = useState([]);
  const [razonesSociales, setRazonesSociales] = useState([]);
  const [aniosDisponibles, setAniosDisponibles] = useState([]);
  const [filtroTemporal, setFiltroTemporal] = useState({ razones: [], anios: [], meses: [] });
  const [filtrosAplicados, setFiltrosAplicados] = useState({ razones: [], anios: [], meses: [] });
  const [mostrarDropdown, setMostrarDropdown] = useState({ razones: false, anios: false, meses: false });

  const refRazones = useRef();
  const refAnios = useRef();
  const refMeses = useRef();

  useEffect(() => {
    fetch(`${API}/ventas-clientes-detalle`)
      .then((res) => res.json())
      .then((data) => {
        setDatos(data);
        const razonesUnicas = [...new Set(data.map((item) => item.razon_social))];
        const aniosUnicos = [...new Set(data.map((item) => new Date(item.fecha).getFullYear()))];
        setRazonesSociales(razonesUnicas);
        setAniosDisponibles(aniosUnicos);
      });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refRazones.current && !refRazones.current.contains(event.target) &&
        refAnios.current && !refAnios.current.contains(event.target) &&
        refMeses.current && !refMeses.current.contains(event.target)
      ) {
        setMostrarDropdown({ razones: false, anios: false, meses: false });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const limpiarMontoChileno = (valor) => {
    if (typeof valor !== "string") valor = String(valor);
    // Eliminar símbolo $ y comas
    valor = valor.replace(/\$/g, "").replace(/,/g, "").trim();
    return parseFloat(valor) || 0;
  };


  const toggleDropdown = (tipo) => {
    setMostrarDropdown((prev) => ({
      razones: tipo === "razones" ? !prev.razones : false,
      anios: tipo === "anios" ? !prev.anios : false,
      meses: tipo === "meses" ? !prev.meses : false,
    }));
  };

  const toggleValor = (valor, lista, tipo) => {
    setFiltroTemporal((prev) => ({
      ...prev,
      [tipo]: lista.includes(valor)
        ? lista.filter((v) => v !== valor)
        : [...lista, valor],
    }));
  };

  const aplicarFiltros = () => {
    setFiltrosAplicados({ ...filtroTemporal });
    setMostrarDropdown({ razones: false, anios: false, meses: false });
  };

  const limpiarFiltros = () => {
    const filtrosVacios = { razones: [], anios: [], meses: [] };
    setFiltroTemporal(filtrosVacios);
    setFiltrosAplicados(filtrosVacios);
    setMostrarDropdown({ razones: false, anios: false, meses: false });
  };

  const hayFiltros = filtroTemporal.razones.length > 0 || filtroTemporal.anios.length > 0 || filtroTemporal.meses.length > 0;

  const datosFiltrados = datos.filter((item) => {
    const fecha = new Date(item.fecha);
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    return (
      (filtrosAplicados.razones.length === 0 || filtrosAplicados.razones.includes(item.razon_social)) &&
      (filtrosAplicados.anios.length === 0 || filtrosAplicados.anios.includes(anio)) &&
      (filtrosAplicados.meses.length === 0 || filtrosAplicados.meses.includes(mes))
    );
  });

  const totalNeto = datosFiltrados.reduce((sum, d) => sum + limpiarMontoChileno(d.neto), 0);
  const totalIVA = datosFiltrados.reduce((sum, d) => sum + limpiarMontoChileno(d.iva), 0);
  const totalTOTAL = datosFiltrados.reduce((sum, d) => sum + limpiarMontoChileno(d.total), 0);

  const pagados = datosFiltrados.filter(d => d.pagado === "SI").length;
  const noPagados = datosFiltrados.filter(d => d.pagado === "NO").length;
  const totalPagos = pagados + noPagados;
  const porcentajePagado = totalPagos > 0 ? (pagados / totalPagos) * 100 : 0;
  const porcentajeNoPagado = 100 - porcentajePagado;

  // Logs para depurar
  console.log("✔ SUMAS:");
  console.log("Neto total:", totalNeto);
  console.log("IVA total:", totalIVA);
  console.log("TOTAL total:", totalTOTAL);

  console.table(datosFiltrados.slice(0, 5).map(d => ({
    razon: d.razon_social,
    neto: limpiarMontoChileno(d.neto),
    iva: limpiarMontoChileno(d.iva),
    total: limpiarMontoChileno(d.total),
  })));

  return (
    <div className="container my-4">
      {/* Filtros */}
      <div className="bg-light p-4 rounded shadow-sm mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-md-3 position-relative" ref={refRazones}>
            <label className="form-label fw-semibold">Razón Social:</label>
            <button onClick={() => toggleDropdown("razones")} className="form-control text-start">
              {filtroTemporal.razones.length > 0 ? `Seleccionados (${filtroTemporal.razones.length})` : "-- Todos --"}
            </button>
            {mostrarDropdown.razones && (
              <div className="position-absolute bg-white border rounded shadow w-100 mt-1 z-3 overflow-auto" style={{ maxHeight: "200px" }}>
                {razonesSociales.map((r, i) => (
                  <label key={i} className="dropdown-item">
                    <input type="checkbox" className="form-check-input me-2" checked={filtroTemporal.razones.includes(r)} onChange={() => toggleValor(r, filtroTemporal.razones, "razones")} />
                    {r}
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="col-md-3 position-relative" ref={refAnios}>
            <label className="form-label fw-semibold">Años:</label>
            <button onClick={() => toggleDropdown("anios")} className="form-control text-start">
              {filtroTemporal.anios.length > 0 ? `Seleccionados (${filtroTemporal.anios.length})` : "-- Todos --"}
            </button>
            {mostrarDropdown.anios && (
              <div className="position-absolute bg-white border rounded shadow w-100 mt-1 z-3 overflow-auto" style={{ maxHeight: "200px" }}>
                {aniosDisponibles.map((anio) => (
                  <label key={anio} className="dropdown-item">
                    <input type="checkbox" className="form-check-input me-2" checked={filtroTemporal.anios.includes(anio)} onChange={() => toggleValor(anio, filtroTemporal.anios, "anios")} />
                    {anio}
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="col-md-3 d-flex gap-2">
            <button onClick={aplicarFiltros} className="btn btn-primary w-100">Aplicar Filtros</button>
            <button onClick={limpiarFiltros} className={`btn ${!hayFiltros ? "btn-secondary disabled" : "btn-danger"}`} disabled={!hayFiltros}>Limpiar</button>
          </div>
        </div>
      </div>

      {/* Indicadores */}
      <Row className="mb-4 g-4">
        <Col md={3}><Card className="text-center shadow-sm"><Card.Body><h6 className="fw-bold">Total Neto</h6><p className="fs-5">${totalNeto.toLocaleString("es-CL")}</p></Card.Body></Card></Col>
        <Col md={3}><Card className="text-center shadow-sm"><Card.Body><h6 className="fw-bold">Total IVA</h6><p className="fs-5">${totalIVA.toLocaleString("es-CL")}</p></Card.Body></Card></Col>
        <Col md={3}><Card className="text-center shadow-sm"><Card.Body><h6 className="fw-bold">Total General</h6><p className="fs-5">${totalTOTAL.toLocaleString("es-CL")}</p></Card.Body></Card></Col>
        <Col md={3}>
          <Card className="text-center shadow-sm">
            <Card.Body>
              <h6 className="fw-bold mb-2">% Pagado vs No</h6>
              <ProgressBar style={{ height: "24px", fontSize: "0.75rem" }}>
                <ProgressBar
                  now={porcentajePagado}
                  variant="success"
                  key={1}
                  label={porcentajePagado > 1 ? `${porcentajePagado.toFixed(1)}%` : ""}
                  minBarLength={porcentajePagado > 0 ? 1 : 0}
                />
                <ProgressBar
                  now={porcentajeNoPagado}
                  variant="danger"
                  key={2}
                  label={porcentajeNoPagado > 5 ? `${porcentajeNoPagado.toFixed(1)}%` : ""}
                  minBarLength={porcentajeNoPagado > 0 ? 5 : 0}
                />
              </ProgressBar>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Nuevo gráfico de lineas*/}
      <GraficoVentasMensuales datos={datosFiltrados} />

      <Row className="mt-5">
        <Col md={6}>
          <GraficoClientesTop20 datos={datosFiltrados} />
        </Col>
        <Col md={6}>
          <GraficoRecurrenciaClientes datos={datosFiltrados} />
        </Col>
      </Row>
    </div>
  );
};

export default Clientes;
